import { motion } from "framer-motion";
import { Sofa, Store, Wrench, Plus } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import Reveal, { fadeUp, stagger } from "./Reveal";

const ICONS = { sofa: Sofa, store: Store, wrench: Wrench };
const TONES = ["bg-brand-blue/15 text-brand-blue border-brand-blue/40", "bg-brand-red/10 text-brand-red border-brand-red/40", "bg-brand-orange/10 text-brand-orange border-brand-orange/40"];

export default function Services() {
  const { content, t } = useSite();
  const s = content?.services;
  if (!s) return null;

  return (
    <section id="services" className="py-24 sm:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="stitch-x w-10 text-brand-blue" />
              <span className="font-mono2 text-xs uppercase tracking-[0.3em] text-brand-blue">{t(s.eyebrow)}</span>
            </div>
            <h2 className="font-display uppercase text-4xl sm:text-5xl leading-[1.02] max-w-xl">{t(s.title)}</h2>
          </div>
          <p className="font-mono2 text-sm text-white/50 max-w-[220px] md:text-right">
            {t(content?.service_area)} - {t(content?.hours)}
          </p>
        </Reveal>

        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.15 }}
          className="grid md:grid-cols-3 gap-6"
        >
          {s.items.map((item, i) => {
            const Icon = ICONS[item.icon] || Sofa;
            return (
              <motion.article
                key={i}
                variants={fadeUp}
                data-testid={`service-card-${i}`}
                className="lift relative rounded-xl border border-white/10 bg-brand-surface p-8 flex flex-col"
              >
                <span className="absolute top-6 right-7 font-display text-4xl text-white/10">0{i + 1}</span>
                <span className={`inline-flex w-14 h-14 items-center justify-center rounded-lg border ${TONES[i % 3]} mb-6`}>
                  <Icon size={26} strokeWidth={2.2} />
                </span>
                <h3 className="font-display uppercase text-2xl mb-3 leading-tight">{t(item.title)}</h3>
                <p className="text-white/65 text-sm leading-relaxed mb-6">{t(item.desc)}</p>
                <ul className="mt-auto space-y-2.5 pt-4 border-t border-dashed border-white/15">
                  {item.items.map((li, j) => (
                    <li key={j} className="flex items-center gap-2.5 text-sm text-white/85">
                      <Plus size={13} className="text-brand-orange shrink-0" strokeWidth={3} />
                      {t(li)}
                    </li>
                  ))}
                </ul>
              </motion.article>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}
